import { render, staticRenderFns } from "./NotificationInboxList.vue?vue&type=template&id=1b3a6778&scoped=true"
import script from "./NotificationInboxList.vue?vue&type=script&lang=js"
export * from "./NotificationInboxList.vue?vue&type=script&lang=js"
import style0 from "./NotificationInboxList.vue?vue&type=style&index=0&id=1b3a6778&prod&lang=scss&scoped=true"
import style1 from "./NotificationInboxList.vue?vue&type=style&index=1&id=1b3a6778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a6778",
  null
  
)

export default component.exports